import { useRouteError } from 'react-router-dom';
import Page from './Page';

export default function ErrorPage() {
  const error = useRouteError();

  return (
    <Page>
      <div id="error-page">
        <h1>Oops!</h1>
        <p>We weren't able to find what you were looking for.</p>
      </div>
    </Page>
  );
}
